import React, { useEffect, useState } from 'react';

export default function ListPager({
  changeLimit,
  nextPage,
  prevPage,
  setPagerIndex,
  totalEvents,
  pagerIndex,
  limit,
  totalPages,
  paginatedItemCount
}) {
  const [isEnd, setEnd] = useState(false);
  const [hide, setHide] = useState(false);
  const paginationSizes = [12, 24, 48, 60];

  const scrollToTop = () => {
    const anchor = document.getElementById('scroll-anchor');
    window.scrollTo({ top: anchor.offsetTop, behavior: 'smooth' });
  };

  useEffect(() => {
    if (pagerIndex === totalPages - 1) setEnd(true);
    if (pagerIndex > 0) scrollToTop();
  }, [pagerIndex]);

  useEffect(() => {
    paginatedItemCount < limit ? setHide(true) : setHide(false);
  }, [paginatedItemCount]);

  return (
    <section className="section u--margin-bottom-50">
      <div className="pagination__section">
        <div className="container container--xl">
          <div className="grid">
            <div className="grid__col-xs-12 grid__col-lg-12">
              <div className="pagination__container">
                {totalEvents > limit ? (
                  <nav>
                    <ul className="pagination pagination--md">
                      {pagerIndex !== 0 && (
                        <li className="pagination__item">
                          <a
                            onClick={() => {
                              prevPage();
                            }}
                          >
                            <i className="icon-arrow2-left-blue"></i>Prev
                          </a>
                        </li>
                      )}
                      {pagerIndex >= 1 && (
                        <li
                          onClick={() => {
                            setPagerIndex(0);
                          }}
                          className="pagination__item"
                        >
                          <a>1</a>
                        </li>
                      )}
                      {pagerIndex > 1 && (
                        <li className="pagination__item">
                          <a
                            onClick={() => {
                              const newIndex = pagerIndex - 1;
                              setPagerIndex(newIndex);
                            }}
                          >
                            {pagerIndex}
                          </a>
                        </li>
                      )}

                      <li className="pagination__item pagination__item--active">
                        <a href="#">{pagerIndex + 1}</a>
                      </li>
                      {pagerIndex !== totalPages - 2 && (
                        <li
                          className={`pagination__item ${
                            isEnd || hide ? 'u--hidden' : ''
                          }`}
                        >
                          <a
                            onClick={() => {
                              const newIndex = pagerIndex + 1;
                              setPagerIndex(newIndex);
                            }}
                          >
                            {pagerIndex + 2}
                          </a>
                        </li>
                      )}

                      {pagerIndex + 1 !== totalPages && (
                        <li className="pagination__item">
                          <a
                            onClick={() => {
                              const newIndex = totalPages - 1;
                              setPagerIndex(newIndex);
                            }}
                          >
                            {totalPages}
                          </a>
                        </li>
                      )}

                      {pagerIndex !== totalPages - 1 && (
                        <li className="pagination__item">
                          <a
                            onClick={() => {
                              nextPage();
                            }}
                          >
                            Next<i className="icon-arrow-right-blue"></i>
                          </a>
                        </li>
                      )}
                    </ul>
                  </nav>
                ) : (
                  <div></div>
                )}
                <div className="pagination__results-per-page">
                  <div className="pagination__results-label">
                    Results per page:
                  </div>
                  <div className="pagination__results-input-wrapper">
                    <select
                      defaultValue={limit}
                      onChange={(e) => {
                        changeLimit(parseInt(e.target.value));
                      }}
                      className="pagination__results-input"
                    >
                      {paginationSizes.map((size) => {
                        if (limit !== size) {
                          return (
                            <option key={size} value={size}>
                              {size}
                            </option>
                          );
                        } else if (limit === size) {
                          return <option key={size}>{size}</option>;
                        }
                      })}
                    </select>
                    <i className="icon-caret-down"></i>
                  </div>
                </div>
              </div>
              <div className="pagination__current-results">
                Showing [{paginatedItemCount}] of [{totalEvents}] Results
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
